import React, { useEffect } from "react";
import { Button, Form, Input, DatePicker, Select, TreeSelect } from "antd";
import { useModel } from "../../../models/index";

const { RangePicker } = DatePicker;
const rangeConfig = {
    rules: [{ type: 'array', required: false, message: '请选择制单时间!' }],
};
export default function () {
    const [form] = Form.useForm();

    const [{ materialSortDict }] = useModel("cmDict");
    const [{ searchParam, searcnPage }, { setSearchParam, resetSearchParam, loadListDetail }] = useModel("dinoutModel");

    useEffect(() => {
        form.setFieldsValue(searchParam);
    }, [searchParam]);

    useEffect(() => {
        form.setFieldsValue(searchParam);
        // onReset();
    }, []);


    const onFinish = () => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const { pageSize, pageNum } = searcnPage
        const { materialCode, category } = searchParam;
        let data = {
            startTime,
            endTime,
            pageSize,
            pageNum:1, 
            materialCode, // "商品编号"
            category, // "商品类型 "
        }
        loadListDetail({ showMsg: true, data });
    }
    const onReset = () => {
        form.resetFields();
        resetSearchParam();
        let data = {
            pageSize: 15,
            pageNum: 1,
        }
        loadListDetail({ showMsg: true, data })
    }
    return (
        <Form
            form={form}
            layout="inline"
            onFinish={onFinish}
            onValuesChange={e => setSearchParam(e)}
        >
            <Form.Item
                name="materialCode"
                label="商品编号"
            >
                <Input placeholder="商品编号" style={{ width: "200px" }} />
            </Form.Item>
            <Form.Item
                style={{ marginBottom: 0, width: 300 }}
                name="category"
                label="商品类型"
            >
                <TreeSelect
                    showSearch
                    allowClear
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder="请选择商品类型"
                    treeDefaultExpandAll
                    onChange={() => {
                    }}
                    treeData={materialSortDict}
                />
            </Form.Item>
            <Form.Item name="checkTime" label="出入库日期" {...rangeConfig}>
                <RangePicker style={{ width: "300px" }} />
            </Form.Item>
            <Form.Item shouldUpdate={true}>
                {() => (
                    <>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            查询
                        </Button>
                        <Button
                            htmlType="button"
                            className="margin-left-8"
                            onClick={onReset}
                        >
                            重置
                        </Button>
                    </>
                )}
            </Form.Item>
        </Form>
    );
}